export default __webpack_public_path__ + "static/media/cdiscount-2.71cbafb8.svg";